
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/saved-cards",
      function () {
        return require("private-next-pages/my-account/saved-cards.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/saved-cards"])
      });
    }
  